export default __webpack_public_path__ + "static/media/david.9fdc0fe0.jpg";